import { IAppState } from '../../redux';
import { IPublishOption } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export function selectFirstPackage(state: IAppState): IPublishOption | null {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { packages, packageIds },
  } = selectedService;

  const firstPackageId = packageIds[0];

  if (!packages[firstPackageId]) {
    return null;
  }

  return packages[firstPackageId];
}
